/**
 * `/api/export/audit` — INV-8 export egress audit trail (PR-E1).
 *
 * Read-only census of `export.emitted` ops rows produced by the production
 * door (`exportArtifact` / `exportForVerifiedTask`). The product surface that
 * proves something left the deployment boundary, by whom, and with which
 * body hash — without ever returning the artifact body itself.
 *
 * Mirror of `listExportAudit` + `countExportEmitted` from
 * `@excellent/core/live-sessions`. The server handler owns the vault handle;
 * this contract never imports core.
 */

import { z } from "zod";
import type { Operation } from "../types";

export const exportAuditRowSchema = z.object({
  id: z.number(),
  artifactClass: z.string(),
  actorId: z.string(),
  itemCount: z.number(),
  bodyHash: z.string(),
  createdAt: z.string(),
});
export type ExportAuditRowDto = z.infer<typeof exportAuditRowSchema>;

export const exportAuditListResultSchema = z.object({
  emittedTotal: z.number(),
  rows: z.array(exportAuditRowSchema),
});
export type ExportAuditListResult = z.infer<typeof exportAuditListResultSchema>;

const listOp: Operation<void, void, void, ExportAuditListResult> = {
  method: "GET",
  path: () => "/api/export/audit",
  response: exportAuditListResultSchema,
};

export const exportAudit = {
  list: listOp,
};
